import { defaultClient as ApolloClient } from "../../../main";
import { GET_PIVOT_PROFILES } from "../../../graphql/reportProfiles/reportProfilesQ";
import {
  PIVOT_PROFILES_ADD,
  PIVOT_PROFILES_DELETE
} from "../../../graphql/reportProfiles/reportProfilesM";

export const actions = {
  // to work here
  allPivotProfiles: ({ commit }) => {
    return ApolloClient.query({
      query: GET_PIVOT_PROFILES
    })
      .then(({ data }) => {
        commit("setPivotProfiles", data.allPivotProfiles);
      })
      .catch(err => {
        console.error(`Error in allPivotProiles action. Full info => ${err}`);
      });
  },

  pivotPofilesAdd: async (context, payload) => {
    ApolloClient.mutate({
      mutation: PIVOT_PROFILES_ADD,
      variables: payload
    })
      .then(({ data }) => {
        const pivotProfilesList = context.state.pivotProfiles;
        console.log("pivotProfilesList=", pivotProfilesList);
        console.log("payload=", payload);
        console.log("data.pivotProfilesAdd", data.pivotProfilesAdd);
        if (payload.profileSeqno === 0) {
          pivotProfilesList.edges.push(data.pivotProfilesAdd.edges);
          context.commit("setPivotProfiles", pivotProfilesList);
        }
      })
      .catch(err => {
        console.error(err);
      });
  },

  pivotProfilesDelete: (context, payload) => {
    ApolloClient.mutate({
      mutation: PIVOT_PROFILES_DELETE,
      variables: payload
    })
      .then(() => {
        const pivotProfilesList = context.state.pivotProfiles;
        const index = pivotProfilesList.edges.findIndex(
          profile => profile.node.profileSeqno === payload.profileSeqno
        );
        if (index > -1) {
          pivotProfilesList.edges.splice(index, 1);
          context.commit("setPivotProfiles", pivotProfilesList);
        }
      })
      .catch(err => {
        console.error(err);
      });
  }
};
